'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _botSessionDetails = require('./bot-session-details.component');

var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botSessionDetailsModule = _angular2.default.module('app.containers.bot-session-details', []).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('botSessionDetails', {
    url: '/bot-sessions/:botSessionId',
    template: '<bot-session-details></bot-session-details>'
  });
}).component('botSessionDetails', _botSessionDetails2.default);

exports.default = botSessionDetailsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-session-details/bot-session-details.js
 **/